import React, {Component} from 'react';
import {Row, Col, Progress, Card, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup,  Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import { ajaxWrapperPost, ajaxWrapperGet, ajaxWrapperDelete } from '../../../utils/deviceAPI';
import classnames from 'classnames';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import UsersNotificationSystem from '../../Admin/Users/UsersNotificationSystem';
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';

class Developer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            activeTab: '1',
            modalDeleteAlarmPoint: false,
            modalDefineBits: false,
            selectedAlarmID: 0,
            selectedAlarmTag: "",
            selectedAlarmTagDesc: "",
            addAlarmTag: "",
            addAlarmDescription: "",
            addAlarmComparisonOperator: "",
            addAlarmAlarmType: "",
            addAlarmConditionValue: 0,
            addAlarmNeverReoccur: false,
            addAlarmShowOnScreen: false,
            bitUnpackData: [
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""},
                {"message" : ""}
            ]

        };
        this.toggleDeleteAlarmPoint = this.toggleDeleteAlarmPoint.bind(this);
        this.deleteAlarmPoint = this.deleteAlarmPoint.bind(this);
        this.toggleDefineBits = this.toggleDefineBits.bind(this);
        this.defineBits = this.defineBits.bind(this);
        this.toggle = this.toggle.bind(this);
        this.saveChangesSelectTag = this.saveChangesSelectTag.bind(this);
        this.saveChangesSelectTagOperator = this.saveChangesSelectTagOperator.bind(this);
        this.saveFormChanges = this.saveFormChanges.bind(this);
        this.addNewAlarmDefaults = this.addNewAlarmDefaults.bind(this);
        this.saveFormChangesBitUnpack = this.saveFormChangesBitUnpack.bind(this);
        this.saveChangesAlarmType = this.saveChangesAlarmType.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.setData(newDev);
        }
    }
    componentWillUnmount(){

    }

    addNewAlarmSubmit() {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            addAlarmTag: this.state.addAlarmTag,
            addAlarmDescription: this.state.addAlarmDescription,
            addAlarmComparisonOperator: this.state.addAlarmComparisonOperator,
            addAlarmConditionValue: this.state.addAlarmConditionValue,
            addAlarmNeverReoccur: this.state.addAlarmNeverReoccur,
            addAlarmShowOnScreen: this.state.addAlarmShowOnScreen,
            addAlarmAlarmType: this.state.addAlarmAlarmType
        };
        ajaxWrapperPost(`/dev/site/addAlarm`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.addNewAlarmDefaults();
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    addNewAlarmDefaults() {
        this.setState({
            addAlarmTag: "",
            addAlarmDescription: "",
            addAlarmComparisonOperator: "",
            addAlarmConditionValue: 0,
            addAlarmNeverReoccur: false,
            addAlarmShowOnScreen: false
        });

    }
    saveFormChanges(event) {
        if (event.target.type === "checkbox") {
            this.setState({[event.target.name]: event.target.checked});
        }
        else {
            this.setState({[event.target.name]: event.target.value});
        }
    }
    saveFormChangesBitUnpack(e,index) {
        let data = this.state.bitUnpackData;
        data[index] = { "message" : e.target.value };
        this.setState({
            bitUnpackData: data
        })
    }
    saveChangesSelectTag(value) {
        this.setState({
            addAlarmTag: value.value
        });
    }
    saveChangesSelectTagOperator(value) {
        this.setState({
            addAlarmComparisonOperator: value.value
        });
    }
    saveChangesAlarmType(value) {
        this.setState({
            addAlarmAlarmType: value.value
        });
    }
    toggleDeleteAlarmPoint() {
        this.setState({
            modalDeleteAlarmPoint: !this.state.modalDeleteAlarmPoint
        });
    }
    toggleDefineBits() {
        this.setState({
            modalDefineBits: !this.state.modalDefineBits
        });
    }
    setData(device = this.props.match.params.dev.replace('device_','')) {
        ajaxWrapperGet('/dev/developer',device).then((data) => {
            console.log(data);
            this.setState({
                data,
                loading: false
            });
        });
    }

    alarmSelected(alarmID = 0, alarmTag = "", alarmTagDesc = "", bitWordData = [] ) {
        this.setState({
            selectedAlarmID: alarmID,
            selectedAlarmTag: alarmTag,
            selectedAlarmTagDesc: alarmTagDesc,
            bitUnpackData: bitWordData
        });
    }
    enableAlarm(method = "", enabled = false, neverReoccur = false, unpackBits = false, alarmID = 0, alarmTag = "", alarmTagDesc = "" ) {
        let postData = {
            enabled: method === "updateEnabled" ? !enabled : enabled,
            neverReoccur: method === "updateNeverReoccur" ? !neverReoccur : neverReoccur,
            unpackBits: method === "updateUnpackBits" ? !unpackBits : unpackBits,
            id: alarmID,
            tag: alarmTag,
            desc: alarmTagDesc

        };
        ajaxWrapperPost(`/dev/site/modifyAlarm`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    deleteAlarmPoint(){
        let postData = {
            id: this.state.selectedAlarmID,
            tag: this.state.selectedAlarmTag,
            desc: this.state.selectedAlarmTagDesc

        };
        ajaxWrapperPost(`/dev/site/deleteAlarm`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
                this.toggleDeleteAlarmPoint();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }
    defineBits(){
        let postData = {
            id: this.state.selectedAlarmID,
            tag: this.state.selectedAlarmTag,
            desc: this.state.selectedAlarmTagDesc,
            bitUnpackData: this.state.bitUnpackData

        };
        ajaxWrapperPost(`/dev/site/modifyAlarmBitPack`,postData).then((data) => {
            if (data.error === false) {
                this.refs.notification.notify(data.message,'success');
                this.setData();
                this.toggleDefineBits();
            }
            else if (data.error === true) {
                this.refs.notification.notify(data.message,'error');
            }
        });
    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    returnTagStructure(tags) {
        let returnStructure = [];
        Object.keys(tags).forEach(function(key) {
            returnStructure.push({
                value: key,
                label: key
            })
        });
        return returnStructure;
    }

    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        const { data } = this.state;
        let tagList = this.returnTagStructure(data.iotData.state.reported.iodb);
        const items = {
            "warning" : "exclamation",
            "danger" : "times",
            "success" : "check",
            "info" : "commenting-o"
        };
        return (
            <div className="animated fadeIn">
                <UsersNotificationSystem ref="notification"/>
                <Row>
                    <Col xs="12" lg="12" className="mb-4">
                        <Card>
                            <CardBody className="card-body">

                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '1' })}
                                            onClick={() => { this.toggle('1'); }}
                                        >
                                            <i className="fa fa-list"></i> <span className={this.state.activeTab === '1' ? '' : 'd-none'}> Alarm List</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '2' })}
                                            onClick={() => { this.toggle('2'); }}
                                        >
                                            <i className="fa fa-plus"></i> <span
                                            className={this.state.activeTab === '2' ? '' : 'd-none'}> Add New Alarm</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="1">
                                        <Row className="pt-3 pb-3">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Available Alarms</CardTitle>
                                                <div className="small text-muted">list of all alarms points.</div>
                                            </Col>
                                            <Col sm="2" className="d-none d-sm-inline-block">
                                                <i className="fa fa-list float-right text-secondary"></i>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <ul className="icons-list mb-5">
                                                    <Table responsive>
                                                        <thead>
                                                        <tr>
                                                            <th>Notify</th>
                                                            <th>Show</th>
                                                            <th>Description</th>
                                                            <th>Variable</th>
                                                            <th>Trigger</th>
                                                            <th>No Repeat</th>
                                                            <th>Unpack Bits</th>
                                                            <th> </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.data.alarms.map((alarm,index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{alarm.enabled ? <i className="fa fa-check text-success"> </i> : <i className="fa fa-times text-secondary"> </i>} {alarm.notifyOnReset ? <i className="fa fa-check text-danger"> </i> : <i className="fa fa-times text-secondary"> </i>}</td>
                                                                    <td>{alarm.showOnAlarmScreen? <i className="fa fa-eye text-info"> </i> : ""}</td>
                                                                    <td>{alarm.alarmDesc}</td>
                                                                    <td>{alarm.alarmName}</td>
                                                                    <td><Badge color="primary text-white">variable</Badge> <Badge color="secondary">{alarm.conditionOperator} {alarm.conditionValue}</Badge></td>
                                                                    <td>{alarm.neverReoccur ? <Badge color="success">True</Badge> : <Badge color="secondary">False</Badge>}</td>
                                                                    <td>{alarm.unpackBits ? alarm.bitWordData === null ? <Badge color="warning">Undefined Bits</Badge> : <Badge color="success">True</Badge> : <Badge color="secondary">False</Badge> }</td>
                                                                    <td className="text-right">
                                                                        <Button outline color={alarm.enabled? "success" : "secondary"} className="btn btn-sm mr-2" onClick={() => {this.enableAlarm("updateEnabled", alarm.enabled, alarm.neverReoccur, alarm.unpackBits, alarm.alarmID,alarm.alarmName,alarm.alarmDesc);}}><i className={alarm.enabled? "fa fa-bell-o " : "fa fa-bell-slash-o"}> </i></Button>
                                                                        <Button outline color={alarm.neverReoccur ? "success" : "secondary"} className="btn btn-sm mr-2" onClick={() => {this.enableAlarm("updateNeverReoccur",alarm.enabled, alarm.neverReoccur, alarm.unpackBits, alarm.alarmID,alarm.alarmName,alarm.alarmDesc);}}><i className="fa fa-repeat"> </i></Button>
                                                                        <Button outline color={alarm.unpackBits ? "success" : "secondary"} className="btn btn-sm mr-2" onClick={() => {this.enableAlarm("updateUnpackBits",alarm.enabled, alarm.neverReoccur, alarm.unpackBits, alarm.alarmID,alarm.alarmName,alarm.alarmDesc);}}><i className={alarm.unpackBits? "fa fa-folder-open-o " : "fa fa-folder-o"}> </i></Button>
                                                                        <Button outline color="info" className="btn btn-sm mr-2" disabled={!alarm.unpackBits} onClick={() => {this.toggleDefineBits(); this.alarmSelected(alarm.alarmID,alarm.alarmName,alarm.alarmDesc, JSON.parse(alarm.bitWordData))}}>Define Bits</Button>
                                                                        <Button outline color="danger" className="btn btn-sm" onClick={() => {this.toggleDeleteAlarmPoint(); this.alarmSelected(alarm.alarmID,alarm.alarmName,alarm.alarmDesc)}}><i className="fa fa-trash-o"> </i></Button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                        </tbody>
                                                    </Table>
                                                </ul>
                                                <Modal isOpen={this.state.modalDeleteAlarmPoint} toggle={this.toggleDeleteAlarmPoint} >

                                                    <ModalBody>
                                                        <Row>
                                                            <Col sm="10">
                                                                <CardTitle className="mb-1">Delete Alarm Point</CardTitle>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="12">
                                                                <hr className="mb-4"/>
                                                            </Col>
                                                        </Row>
                                                        <Row className="pb-2">
                                                            <Col sm="12">
                                                                <div className="text-center">Are you sure you want to delete the alarm point <br /> {this.state.selectedAlarmTag} ({this.state.selectedAlarmTagDesc})  ? This will also delete the history for this alarm point.</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="12">
                                                                <hr className="mb-4"/>
                                                            </Col>
                                                        </Row>
                                                        <Row className="pb-4">
                                                            <Col sm="6" className="small text-muted">
                                                                <Button color="link" className="btn btn-block" onClick={this.toggleDeleteAlarmPoint}>Cancel</Button>
                                                            </Col>
                                                            <Col sm="6" className="small text-muted">
                                                                <Button color="danger" className="btn btn-block" onClick={this.deleteAlarmPoint} >Delete</Button>
                                                            </Col>
                                                        </Row>
                                                    </ModalBody>
                                                </Modal>
                                                <Modal isOpen={this.state.modalDefineBits} toggle={this.toggleDefineBits} className="modal-lg">
                                                    <ModalBody>
                                                        <Row>
                                                            <Col sm="10">
                                                                <CardTitle className="mb-1">Define Bits</CardTitle>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="12">
                                                                <hr className="mb-4"/>
                                                            </Col>
                                                        </Row>
                                                        <Row className="pb-2">
                                                            {this.state.bitUnpackData.map((message, index) => {
                                                                return (
                                                                    <Col key={index} sm="6">
                                                                        <FormGroup row>
                                                                            <Col xs="3">
                                                                                <Label htmlFor="select">{index}</Label>
                                                                            </Col>
                                                                            <Col xs="9">
                                                                                <Input type="text" id="defineBi-t00" name="defineBit-00" placeholder="" value={this.state.bitUnpackData[index]['message']} onChange={(e) => {this.saveFormChangesBitUnpack(e,index)}}/>
                                                                            </Col>
                                                                        </FormGroup>
                                                                    </Col>
                                                                )
                                                            })}
                                                        </Row>
                                                        <Row>
                                                            <Col sm="12">
                                                                <hr className="mb-4"/>
                                                            </Col>
                                                        </Row>
                                                        <Row className="pb-4">
                                                            <Col sm="6" className="small text-muted">
                                                                <Button color="link" className="btn btn-block" onClick={this.toggleDefineBits}>Cancel</Button>
                                                            </Col>
                                                            <Col sm="6" className="small text-muted">
                                                                <Button color="success" className="btn btn-block" onClick={this.defineBits} >Save</Button>
                                                            </Col>
                                                        </Row>
                                                    </ModalBody>
                                                </Modal>
                                            </Col>

                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row className="pt-3 pb-3">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Add Alarm</CardTitle>
                                                <div className="small text-muted">Add a new alarm by filling the form below.</div>
                                            </Col>
                                            <Col sm="2" className="d-none d-sm-inline-block">
                                                <i className="fa fa-list float-right text-secondary"></i>
                                            </Col>
                                        </Row>
                                        <Row className="pt-4">
                                            <Col sm="8">
                                                <FormGroup row>
                                                    <Col xs="12" md="12">
                                                        <Select
                                                            name="form-field-name2"
                                                            value={this.state.addAlarmTag}
                                                            options={tagList}
                                                            onChange={this.saveChangesSelectTag}
                                                        />
                                                        <FormText color="muted">Select the variable which will trigger the alarm.</FormText>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="2">
                                                <FormGroup row>
                                                    <Col xs="12">
                                                        <Select
                                                            name="form-field-name2"
                                                            value={this.state.addAlarmComparisonOperator}
                                                            options={[
                                                                { value: '=', label: '=' },
                                                                { value: '>', label: '>' },
                                                                { value: '>=', label: '>=' },
                                                                { value: '<', label: '<' },
                                                                { value: '<=', label: '<=' }
                                                            ]}
                                                            onChange={this.saveChangesSelectTagOperator}
                                                        />
                                                        <FormText color="muted">Select the comparison operator.</FormText>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="2">
                                                <FormGroup row>
                                                    <Col xs="12">
                                                        <Input type="number" id="addAlarmConditionValue" name="addAlarmConditionValue" placeholder="" value={this.state.addAlarmConditionValue} onChange={this.saveFormChanges}/>
                                                        <FormText color="muted">Insert Value to compare against</FormText>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="8">
                                                <FormGroup row>
                                                    <Col xs="12">
                                                        <Input type="text" id="addAlarmDescription" name="addAlarmDescription" placeholder="" value={this.state.addAlarmDescription} onChange={this.saveFormChanges}/>
                                                        <FormText color="muted">Type the variable's description, this will be used as the message sent to the notification list and as the message displayed to users if bits are not unpacked.</FormText>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="2">
                                                <FormGroup row>
                                                    <Col xs="12">
                                                        <Select
                                                            name="form-field-name2"
                                                            value={this.state.addAlarmAlarmType}
                                                            options={[
                                                                { value: 'danger', label: 'Danger' },
                                                                { value: 'warning', label: 'Warning' },
                                                                { value: 'success', label: 'Success' },
                                                                { value: 'info', label: 'Information' },
                                                            ]}
                                                            onChange={this.saveChangesAlarmType}
                                                        />
                                                        <FormText color="muted">Select the alarm type.</FormText>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <hr className="mb-4"/>
                                        <Row>
                                            <Col sm="12">
                                                <FormGroup check className="checkbox">
                                                    <Input className="form-check-input" type="checkbox" id="addAlarmNeverReoccur" name="addAlarmNeverReoccur" value={this.state.addAlarmNeverReoccur} onChange={this.saveFormChanges}/>
                                                    <FormText color="muted">Never Reoccur : Enable this if you only want the alarm to be issued once when it occurs.</FormText>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <FormGroup check className="checkbox">
                                                    <Input className="form-check-input" type="checkbox" id="addAlarmShowOnScreen" name="addAlarmShowOnScreen" value={this.state.addAlarmShowOnScreen} onChange={this.saveFormChanges} checked={this.state.addAlarmShowOnScreen}/>
                                                    <FormText color="muted">Show Alarm on Screen: Enable this if you want this alarm to show up on the alarm screen.</FormText>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <hr className="mb-4 mt-4"/>
                                        <Row className="pt-3 pb-3">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Alarm Preview</CardTitle>
                                                <div className="small text-muted">Preview how the alarm will look on the alarm screen.</div>
                                            </Col>
                                            <Col sm="2" className="d-none d-sm-inline-block">
                                                <i className="fa fa-list float-right text-secondary"></i>
                                            </Col>
                                        </Row>
                                        <Row className="pb-2">
                                            <Col sm="12">
                                                <ul className="icons-list mb-5 list-inline">
                                                    <li className="mb-2 mt-2">
                                                        <i className={`fa fa-${items[this.state.addAlarmAlarmType]} bg-${this.state.addAlarmAlarmType}`}> </i>
                                                        <div className="desc">
                                                            <div className="title">{this.state.addAlarmDescription}</div>
                                                            <div className="small text-muted text-uppercase pb-3">{this.state.addAlarmTag.toUpperCase()}</div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </Col>
                                        </Row>
                                        <hr className="mb-4 mt-4"/>
                                        <Row>
                                            <Col sm="8">
                                            </Col>
                                            <Col sm="4">
                                                <Button color="success" block onClick={() => {this.addNewAlarmSubmit();}}>Add New Alarm</Button>
                                            </Col>
                                        </Row>



                                    </TabPane>
                                </TabContent>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}


export default Developer;



// WEBPACK FOOTER //
// ./src/views/site/Developer/Developer.js